// src/stores/car.js
import { defineStore } from "pinia";
import { httpRequest } from "@/services/api";
import { showAlert } from "@/composables/useAlert";

export const useFavoriteStore = defineStore("favorite", {
  state: () => ({
    services: [],
    isLoading: false,
    myCars: [],
  }),

  actions: {
    async getFavoriteCars() {
      this.isLoading = true;
      try {
        const res = await httpRequest(`/user/favorite?pageSize=-1`, { method: "GET" });
        this.myCars = res.data || [];
      } catch (error) {
        showAlert(
          error.response?.data?.message || "حدث خطأ أثناء جلب البيانات",
          "error"
        );
      } finally {
        this.isLoading = false;
      }
    },
    async toggleFavorite(id) {
      this.isLoading = true;
      try {
        const res = await httpRequest(`/user/make-as-favorite/${id}`, {
          method: "POST",
        });
      } catch (error) {
        showAlert(
          error.response?.data?.message || "حدث خطأ أثناء جلب البيانات",
          "error"
        );
      } finally {
        this.isLoading = false;
      }
    },
  },
});
